module.exports = __webpack_public_path__ + "img/1440.d7f05582.jpg";